import { render, staticRenderFns } from "./SignUpPage.vue?vue&type=template&id=0831dd1e&scoped=true"
import script from "./SignUpPage.vue?vue&type=script&lang=js"
export * from "./SignUpPage.vue?vue&type=script&lang=js"
import style0 from "./SignUpPage.vue?vue&type=style&index=0&id=0831dd1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0831dd1e",
  null
  
)

export default component.exports